<template>
  <div>
    <Select
      :itemSelected="localSample"
      :items="items"
      labelProp="name"
      :hasSearch="true"
      padding="md"
      placeholderSearch="Choose sample"
      titleBottomSheet="Choose sample"
      @update:itemSelected="selectedItemChanged"
      @search="getListItemsDebounced"
      @showPopup="handleShowPopup"
      @hidePopup="handleHidePopup"
    />
  </div>
</template>

<script>
  import Select from '@/uikitBase/selects/vueSelect/Select';
  import _, { debounce } from 'lodash';
  import { apiSamples } from '@/api/graphql/cloud/samples';

  const SEARCH_LIMIT = 25;
  const SEARCH_DELAY = 200;

  const ModelEvent = 'change';

  export default {
    name: 'SelectSample',

    components: { Select },

    model: {
      prop: 'sample',
      event: ModelEvent,
    },

    props: {
      sample: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      isSearchActive: false,
      searchQuery: null,
      items: [],
      localSample: null,

      getListItemsDebounced: null,

      isSelectOpened: false,
    }),

    watch: {
      sample: {
        handler(sample, oldSample) {
          if (sample) {
            this.addItem(sample);

            if (this.isSelectOpened && _.isEqual(sample, oldSample)) {
              return;
            }

            this.localSample = sample;
          }
        },
        immediate: true,
      },
    },

    created() {
      // / NOTE: using hash instead of searching in array
      this.itemsHash = {};

      this.getListItemsDebounced = debounce(this.search, SEARCH_DELAY);

      this.search(null);
    },

    methods: {
      handleShowPopup() {
        this.isSelectOpened = true;
        this.$emit('showPopup');
      },
      handleHidePopup() {
        this.isSelectOpened = false;
        this.$emit('hidePopup');
      },

      selectedItemChanged(item) {
        this.$emit(ModelEvent, item);
      },

      async search(query) {
        const searchingFirstTime =
          query == null && this.searchQuery == null && this.items.length === 0;

        this.isSearchActive = !searchingFirstTime;
        this.searchQuery = query;

        try {
          const { samples } = await apiSamples.getSamples({
            search: this.searchQuery,
            isArchived: this.archived,
            limit: SEARCH_LIMIT,
          });

          if (this.searchQuery !== query) return;
          this.replaceItems(samples);
        } catch {
          if (this.searchQuery !== query) return;
          this.clearItems();
        } finally {
          this.isSearchActive = false;
        }
      },

      addItem(itemNew) {
        this.itemsHash = this.itemsHash ?? [];

        if (!(itemNew.id in this.itemsHash)) {
          this.itemsHash[itemNew.id] = true;
          this.items.unshift(itemNew);
        }
      },

      replaceItems(items) {
        if (!_.isEqual(items, this.items)) {
          this.itemsHash = {};
          items.forEach((item) => {
            this.itemsHash[item.id] = true;
          });
          this.items = items;
        }
      },

      clearItems() {
        this.itemsHash = {};
        this.items = [];
      },
    },
  };
</script>
